// Limpieza por pasos (protocolos secuenciales): configuración, editor y progreso.
export const housekeepingProtocol = {
  // ── Botón de la cabecera del tablero (antes «Recordatorios») ──
  settingsBtn: "Configuración",
  settingsTitle: "Modo de limpieza y recordatorios",

  // ── Drawer de configuración ──
  drawer: {
    title: "Configuración de limpieza",
    subtitle: "Cómo trabaja tu equipo en cada propiedad y cuándo se le avisa.",
    tabMode: "Modo de limpieza",
    tabReminders: "Recordatorios",
  },

  mode: {
    label: "¿Cómo se limpia?",
    standardTitle: "Estándar",
    standardDesc: "Marcar limpia, fotos y código, como hasta ahora.",
    sequentialTitle: "Por pasos (secuencial)",
    sequentialDesc: "Protocolo con tramos y tareas; no se puede pasar de tramo sin terminar el anterior.",
    recommended: "Nuevo",
    protocolLabel: "Protocolo",
    protocolPlaceholder: "Elige un protocolo…",
    noProtocols: "Aún no tienes protocolos. Crea uno desde la plantilla SOP o empieza de cero.",
    protocolMeta: "{etapas} tramos · {tareas} tareas · v{version}",
    usedIn: "Lo usan {count} propiedades",
    fromTemplate: "Crear desde plantilla SOP",
    newProtocol: "Nuevo protocolo",
    editProtocol: "Editar protocolo",
    clone: "Clonar a otras propiedades",
    creating: "Creando…",
    templateName: "Protocolo SOP",
    newProtocolName: "Nuevo protocolo",
    needProtocol: "Elige o crea un protocolo para activar la limpieza por pasos.",
    allNote: "El modo elegido se aplicará a todas tus propiedades.",
    saved: "Modo de limpieza guardado",
    errorLoad: "No se pudieron cargar los protocolos",
    errorSave: "No se pudo guardar. Inténtalo de nuevo.",
    errorCreate: "No se pudo crear el protocolo",
    howTitle: "¿Cómo funciona?",
    howText: "En el móvil, el personal verá los tramos en orden. Cada tarea se marca al hacerla y, si pide foto, no se puede marcar sin ella. El siguiente tramo se desbloquea al terminar el anterior.",
  },

  settings: {
    title: "Configuración de limpieza",
    subtitle: "Elige una propiedad a la izquierda para ver y cambiar cómo se limpia.",
    search: "Buscar propiedad…",
    loading: "Cargando propiedades…",
    tagStd: "Estándar",
    tagSteps: "Por pasos",
    tagRule: "Cada día | Cada {count} días",
    tagBell: "Avisos",
    listFoot: "{steps} por pasos · {rules} con regla de estancias largas · {total} propiedades",
    pick: "Elige una propiedad de la lista.",
    unsaved: "Sin guardar",
    copyBtn: "Copiar a otras propiedades",
    copyHelp: "Se copiará todo lo de esta propiedad (cómo se limpia, reglas y avisos) a las que marques.",
    copyDo: "Copiar a {count} propiedad | Copiar a {count} propiedades",
    copied: "Copiado a {count} propiedad | Copiado a {count} propiedades",
    howTitle: "¿Cómo se limpia?",
    howHelp: "La forma de trabajar del equipo en esta propiedad.",
    pickProtocol: "Elige un protocolo…",
    tasks: "{count} tarea | {count} tareas",
    rulesTitle: "Reglas de limpieza",
    rulesHelp: "Cuándo una habitación pasa sola a «Por limpiar», aunque nadie salga ese día.",
    longStayRule: "Limpiar durante las estancias largas",
    longStayRuleHelp: "Si un huésped se queda varios días, la habitación vuelve a «Por limpiar» cada cierto tiempo.",
    longStayExample: "Ejemplo: entra el lunes y se queda una semana → aparecerá «Por limpiar» cada día. | Ejemplo: entra el lunes y se queda una semana → aparecerá «Por limpiar» cada {count} días, contando desde la última limpieza.",
    alertsTitle: "Avisos al equipo",
    alertsHelp: "Mensajes en el móvil para que nada se quede sin hacer. No cambian la lista de limpieza.",
    arrivalsAlert: "Avisar de llegadas y salidas sin limpiar",
    arrivalsAlertHelp: "Si una habitación con entrada o salida próxima no está lista, se avisa al equipo.",
    longStayAlsoAlerts: "La regla de estancias largas también avisa al equipo, a esta hora y a estas personas.",
    save: "Guardar cambios",
    saveError: "No se pudo guardar",
    discard: "Hay cambios sin guardar. ¿Descartarlos?",
  },
  clone: {
    title: "Clonar «{name}»",
    help: "Elige a qué propiedades copiarlo. Quedarán en modo «Por pasos» con su copia asignada.",
    onePerProperty: "Una copia independiente por propiedad",
    onePerPropertyHelp: "Así cada propiedad puede ajustar su protocolo sin afectar a las demás. Si lo desactivas, todas comparten una sola copia.",
    selectAll: "Todas",
    selectNone: "Ninguna",
    confirm: "Clonar a {count}",
    cancel: "Cancelar",
    done: "Protocolo clonado en {count} propiedad | Protocolo clonado en {count} propiedades",
    error: "No se pudo clonar el protocolo",
    current: "(actual)",
  },

  // ── Editor de protocolo ──
  editor: {
    back: "Limpieza",
    namePlaceholder: "Nombre del protocolo",
    descriptionPlaceholder: "Descripción breve (opcional): para qué tipo de limpieza es…",
    version: "v{n}",
    viewList: "Lista",
    viewFlow: "Flujo",
    addStage: "Añadir tramo",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Protocolo guardado",
    errorSave: "No se pudo guardar el protocolo",
    unsaved: "Cambios sin guardar",
    allSaved: "Todo guardado",
    loading: "Cargando protocolo…",
    notFound: "No se encontró este protocolo.",
    summary: "{etapas} tramos · {tareas} tareas · ~{minutos} min",
    leaveTitle: "¿Salir sin guardar?",
    leaveMessage: "Tienes cambios en el protocolo que todavía no se han guardado. Si sales ahora, se perderán.",
    leaveConfirm: "Salir sin guardar",
    leaveCancel: "Seguir editando",
    emptyTitle: "Este protocolo está vacío",
    emptyText: "Añade el primer tramo (por ejemplo «Ventilar y retirar ropa») y dentro sus tareas.",
  },

  stage: {
    defaultTitle: "Tramo {n}",
    number: "Tramo {n}",
    titlePlaceholder: "Nombre del tramo",
    descriptionPlaceholder: "Descripción del tramo (opcional)",
    minutes: "min",
    minutesTitle: "Minutos estimados",
    duplicate: "Duplicar tramo",
    copySuffix: "(copia)",
    delete: "Eliminar tramo",
    deleteTitle: "¿Eliminar «{name}»?",
    deleteMessage: "Se eliminará el tramo y sus {count} tareas.",
    deleteConfirm: "Eliminar",
    cancel: "Cancelar",
    menu: "Opciones del tramo",
    tasks: "sin tareas | 1 tarea | {count} tareas",
    addTask: "Añadir tarea",
    emptyTasks: "Arrastra tareas aquí o añade una nueva",
    dragHandle: "Arrastra para reordenar",
  },

  task: {
    defaultTitle: "Nueva tarea",
    editorTitle: "Editar tarea",
    inStage: "En «{stage}»",
    titleLabel: "Tarea",
    titlePlaceholder: "Qué hay que hacer",
    instructionsLabel: "Instrucciones",
    instructionsPlaceholder: "Cómo hacerlo bien: productos, orden, detalles que no se pueden olvidar…",
    photoLabel: "Foto de evidencia",
    photoNone: "Ninguna",
    photoOptional: "Opcional",
    photoRequired: "Obligatoria",
    minPhotosLabel: "Mínimo de fotos",
    critical: "Tarea crítica",
    criticalHelp: "Se destaca en rojo y no se puede saltar.",
    delete: "Eliminar tarea",
    close: "Cerrar",
    badgePhoto: "Foto",
    badgePhotoReq: "Foto ×{n}",
    badgeCritical: "Crítica",
    untitled: "(sin título)",
  },

  flow: {
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    fit: "Ajustar",
    autoLayout: "Ordenar automáticamente",
    hint: "Arrastra el fondo para moverte · rueda para zoom · arrastra tareas entre tramos",
    minutes: "{n} min",
  },

  // ── Progreso en el tablero ──
  board: {
    stepPill: "Paso {hechas}/{total} · {etapa}",
    stepDone: "Pasos {hechas}/{total} · completada",
    stepTip: "Limpieza por pasos en curso{persona}",
    by: " · {name}",
    sequentialChip: "Por pasos",
    sequentialTip: "Esta propiedad limpia con un protocolo por pasos. Aún no se ha empezado.",
  },

  // ── Sección del drawer del espacio ──
  runs: {
    title: "Limpieza por pasos",
    loading: "Cargando ejecuciones…",
    empty: "Todavía no hay limpiezas por pasos en este espacio.",
    open: "Ver detalle",
    latest: "Última",
    history: "Anteriores",
    hide: "Ocultar detalle",
    progress: "{hechas}/{total} tareas",
    currentStage: "Ahora: {etapa}",
    startedAt: "Empezó {date}",
    finishedAt: "Terminó {date}",
    by: "por {name}",
    locked: "Bloqueado",
    stageDone: "Completado",
    critical: "Crítica",
    noteLabel: "Nota",
    loadError: "No se pudo cargar la ejecución",
    status: {
      in_progress: "En curso",
      completed: "Completada",
      done: "Completada",
      cancelled: "Cancelada",
      abandoned: "Abandonada",
      pending: "Pendiente",
    },
  },
};
